import { useMutation } from "@tanstack/react-query";
import { postApiCcofPracticeIdCaptureInitiate } from "@/lib/api-client/endpoints/ccof-capture/ccof-capture";

export function useInitiateCaptureLink(practiceId: string, patientId: string) {
  const mutation = useMutation({
    mutationFn: async () => {
      const response = await postApiCcofPracticeIdCaptureInitiate(practiceId, {
        patientId,
      });

      if (!response.data.smsSent) throw new Error();

      return response.data;
    },
  });

  return {
    initiate: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error,
  };
}
